import { render, staticRenderFns } from "./MemberNotificationDetail.vue?vue&type=template&id=1b4bdbc2&scoped=true&"
import script from "./MemberNotificationDetail.vue?vue&type=script&lang=js&"
export * from "./MemberNotificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberNotificationDetail.vue?vue&type=style&index=0&id=1b4bdbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4bdbc2",
  null
  
)

export default component.exports